/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';

import Colors from '../../constants/Colors';
import Link from './Link';

const isInternalURL = to => {
  try {
    const url = new window.URL(to, window.location.origin);
    return url.hostname === window.location.hostname;
  } catch (e) {
    return false;
  }
};

const Card = ({
  elevated = false,
  padded = true,
  bordered = false,
  to,
  children,
  className,
  ...rest
}: {
  elevated?: boolean,
  padded?: boolean,
  bordered?: boolean,
  className?: string,
  to?: string,
  children?: any,
}) => {
  let El = null;
  if (to) {
    if (isInternalURL(to)) {
      El = Link;
    } else {
      El = 'a';
    }
  } else {
    El = 'div';
  }

  let props = {};
  if (to && !isInternalURL(to)) {
    props = { href: to };
  } else {
    props = { to };
  }

  return (
    <El
      className={names(
        Styles.Card,
        padded && Styles.Padded,
        elevated && Styles.Elevated,
        bordered && Styles.Bordered,
        to && Styles.Link,
        className
      )}
      {...props}
      {...rest}>
      {children}
    </El>
  );
};

export default Card;

const Styles = {
  Card: css`
    align-items: center;
    display: flex;
    background-color: ${Colors.White};
    border-radius: 10px;
    flex-direction: column;
    justify-content: flex-start;
    text-align: center;
  `,
  Link: css`
    &:hover {
      box-shadow: 0 12px 50px 0 rgba(0, 0, 0, 0.1);
      transform: scale(1.02);
      transition: all 200ms ease;
    }
  `,
  Padded: css`
    padding: 32px;
  `,
  Elevated: css`
    box-shadow: 0 12px 40px 0 rgba(0, 0, 0, 0.05);
  `,
  Bordered: css`
    border: 1px solid rgba(0, 0, 0, 0.02);
  `,
};



// WEBPACK FOOTER //
// ./src/ui/components/core/Card.js